import common from './common.json';
import engagement from '../modules/engagement/locales/en.json';

const combined: Record<string, unknown> = {
  common,
  ...engagement,
};

export default combined;
